module.exports = __webpack_public_path__ + "img/a1.43803687.jpg";